module.exports = __webpack_public_path__ + "img/户型.765ba6d9.webp";